import { useMutation as e } from "@maat/store-hooks";
import { notificationsApi as t } from "@maat/api-notifications";
//#region src/notifications/useRegisterPushTokenMutation.ts
var n = () => e({ mutationFn: (e) => t.registerPushToken(e) });
//#endregion
export { n as useRegisterPushTokenMutation };
